import {useTheme} from '@mui/material/styles';

import NoResultsIcon from 'components/icons/placeholders/noResults.svg';
import {Placeholder, PlaceholderProps} from 'components/Placeholder';

export type BaseNoResultsPlaceholderProps = Omit<PlaceholderProps, 'heading'> &
  Partial<Pick<PlaceholderProps, 'heading'>>;

export function BaseNoResultsPlaceholder(props: BaseNoResultsPlaceholderProps) {
  const theme = useTheme();

  return <Placeholder icon={<NoResultsIcon color={theme.palette.text.secondary} />} heading='No results' {...props} />;
}
